let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hCSGm")).then(() => parcelRequire('jnEJY'));